export const environment = {
  production: true,
  devApiProxy: false,
  sentryDsn: "https://ae6e39acc23c186466d3ef606c6a63fa@o4507854370308096.ingest.us.sentry.io/4507854382301184",
  logRocket: {
    enabled: true,
    appId: 'ftdi1s/qrowntech'
  }
};